import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

export default function appSchema(context: {
  to: RouteLocationNormalized;
}): NavigationGuardReturn | void {
  const { to } = context;
  const appStore = useAppStore();

  if (appStore.mobileType !== 'iOS' && appStore.mobileType !== 'Android') return;

  const { open } = useSchemaAppStoreFn();
  const domain = window.location.host;

  open({
    domain,
    path: to.fullPath
  });

  return false;
}
